<template>
  <div>
    <TableAggregationsToolbar
      v-if="!isInitialLoading && aggregations"
      :aggregations="aggregations"
    ></TableAggregationsToolbar>
    <b-skeleton v-if="isInitialLoading" width="300px" height="24px"></b-skeleton>
  </div>
</template>

<script>
import TableAggregationsToolbar from '@/components/common/table-aggregations-toolbar';
import apiService from '@/core/common/services/api.service';
import { File, Check, Ban, Users } from 'lucide-vue';

export default {
  components: { TableAggregationsToolbar },
  props: {
    shouldRefresh: {
      type: Boolean,
    },
  },
  data() {
    return {
      isInitialLoading: true,
      aggregations: null,
    };
  },
  watch: {
    shouldRefresh: {
      immediate: true,
      handler: async function (shouldRefresh) {
        if (shouldRefresh) {
          const odataAggregate = await this.getAggregationsByFilter();
          if (!odataAggregate) return;
          const transformedAggregate = this.transformAggregateData(odataAggregate);
          this.aggregations = [
            {
              data: transformedAggregate.New || '-',
              title: this.$t('COMMON.NEU'),
              iconComponent: File,
              iconColor: '#3699FF',
            },
            {
              data: transformedAggregate.Merged || '-',
              title: this.$t('DUBLETTEN.CONFIRMATION.MERGED'),
              iconComponent: Check,
              iconColor: '#1BC5BD',
            },
            {
              data: transformedAggregate.Declined || '-',
              title: this.$t('DUBLETTEN.CONFIRMATION.DECLINED'),
              iconComponent: Ban,
              iconColor: '#F64E60',
            },
            {
              data: transformedAggregate.total || '-',
              title: this.$t('COMMON.INSGESAMT'),
              iconComponent: Users,
              iconColor: '#B5B5C3',
            },
          ];
        }
      },
    },
  },
  methods: {
    async getAggregationsByFilter() {
      try {
        const response = await apiService.get(
          'KundeDuplicate?$apply=groupby(((state)),aggregate($count as $count))&$count=true'
        );
        return response.data.result.value;
      } catch (error) {
        console.error(error);
      } finally {
        this.isInitialLoading = false;
      }
    },
    transformAggregateData(data) {
      return data.reduce(
        (acc, cur) => {
          if (!Object.prototype.hasOwnProperty.call(acc, cur.state)) {
            acc[cur.state] = cur.$count;
            acc.total += cur.$count;
          }
          return acc;
        },
        { total: 0 }
      );
    },
  },
};
</script>
